var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "market-list-form" },
    [
      _c(
        "el-radio-group",
        {
          staticStyle: { "margin-bottom": "30px" },
          model: {
            value: _vm.activeSetting,
            callback: function ($$v) {
              _vm.activeSetting = $$v
            },
            expression: "activeSetting",
          },
        },
        [
          _c("el-radio-button", { attrs: { label: 1 } }, [_vm._v("内容")]),
          _vm._v(" "),
          _c("el-radio-button", { attrs: { label: 2 } }, [_vm._v("样式")]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.activeSetting == 1,
              expression: "activeSetting==1",
            },
          ],
        },
        [
          _c(
            "transition-group",
            { attrs: { name: "fade", tag: "div" } },
            _vm._l(_vm.form.marketLists, function (item, index) {
              return _c(
                "div",
                {
                  key: index,
                  ref: "formItemRefs",
                  refInFor: true,
                  staticClass: "market-item",
                  class: {
                    dragstart: _vm.dragStartIndex === index,
                    dragging: _vm.dragging === index,
                  },
                  on: {
                    dragend: _vm.dragend,
                    dragover: _vm.dragover,
                    dragenter: function ($event) {
                      return _vm.handleDragenter(index)
                    },
                  },
                },
                [
                  _c(
                    "Card",
                    {
                      attrs: { isErrorBtn: !_vm.isAlone },
                      on: {
                        handleRemove: function ($event) {
                          return _vm.handleRemove(index)
                        },
                        handleDragstart: function (e) {
                          return _vm.dragstart(e, index)
                        },
                      },
                    },
                    [
                      !_vm.isAlone
                        ? _c(
                            "div",
                            {
                              staticClass: "flex",
                              staticStyle: { "margin-bottom": "15px" },
                            },
                            [
                              _c(
                                "div",
                                { staticStyle: { "margin-right": "10px" } },
                                [_vm._v("标题：")]
                              ),
                              _vm._v(" "),
                              _c("el-input", {
                                staticStyle: { width: "180px" },
                                attrs: { min: 0 },
                                model: {
                                  value: item.headtitle,
                                  callback: function ($$v) {
                                    _vm.$set(item, "headtitle", $$v)
                                  },
                                  expression: "item.headtitle",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "flex",
                          staticStyle: { "align-items": "baseline" },
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { "margin-right": "10px" } },
                            [_vm._v("内容：")]
                          ),
                          _vm._v(" "),
                          _c("div", [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  color: "#0467e5",
                                  cursor: "pointer",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.settingMarketItem(index, item)
                                  },
                                },
                              },
                              [_vm._v("内容设置")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "font-size": "12px",
                                  width: "200px",
                                  "margin-top": "4px",
                                },
                              },
                              [
                                _vm._v(
                                  "当前设置：指定分类指定分类指定分类指定分类"
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              )
            }),
            0
          ),
          _vm._v(" "),
          _c("el-divider"),
          _vm._v(" "),
          !_vm.isAlone
            ? _c(
                "el-button",
                {
                  staticClass: "add-btn",
                  staticStyle: { width: "100%" },
                  attrs: { type: "primary" },
                  on: { click: _vm.addMarketContent },
                },
                [_vm._v("添加模块")]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.activeSetting == 2,
              expression: "activeSetting==2",
            },
          ],
          attrs: {
            model: _vm.form,
            "label-width": "130px",
            "label-position": "top",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "标题位置：" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.form.styleSetting.titleAlign,
                    callback: function ($$v) {
                      _vm.$set(_vm.form.styleSetting, "titleAlign", $$v)
                    },
                    expression: "form.styleSetting.titleAlign",
                  },
                },
                _vm._l(_vm.TITLE_ALIGN_OPTIONS, function (item) {
                  return _c(
                    "el-radio",
                    { key: item.key, attrs: { label: item.key } },
                    [_vm._v(_vm._s(item.name))]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "展示方式：" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.form.styleSetting.showType,
                    callback: function ($$v) {
                      _vm.$set(_vm.form.styleSetting, "showType", $$v)
                    },
                    expression: "form.styleSetting.showType",
                  },
                },
                [
                  _vm._l(_vm.SHOW_ALIGN_OPTIONS, function (item) {
                    return _c(
                      "el-radio",
                      { key: item.key, attrs: { label: item.key } },
                      [_vm._v(_vm._s(item.name))]
                    )
                  }),
                  _vm._v(" "),
                  _vm.isAlone
                    ? _c("el-radio", { attrs: { label: 3 } }, [
                        _vm._v("横向排列"),
                      ])
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "排序方式：" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.form.styleSetting.sortType,
                    callback: function ($$v) {
                      _vm.$set(_vm.form.styleSetting, "sortType", $$v)
                    },
                    expression: "form.styleSetting.sortType",
                  },
                },
                _vm._l(_vm.SORT_OPTIONS, function (item) {
                  return _c(
                    "el-radio",
                    { key: item.key, attrs: { label: item.key } },
                    [_vm._v(_vm._s(item.name))]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "是否显示商品名称：" } },
            [
              _c("el-switch", {
                attrs: {
                  "active-value": 1,
                  "active-text": "显示",
                  "inactive-text": "隐藏",
                  "inactive-value": 0,
                },
                model: {
                  value: _vm.form.styleSetting.showTitle,
                  callback: function ($$v) {
                    _vm.$set(_vm.form.styleSetting, "showTitle", $$v)
                  },
                  expression: "form.styleSetting.showTitle",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "是否显示商品价格：" } },
            [
              _c("el-switch", {
                attrs: {
                  "active-value": 1,
                  "active-text": "显示",
                  "inactive-text": "隐藏",
                  "inactive-value": 0,
                },
                model: {
                  value: _vm.form.styleSetting.showPrice,
                  callback: function ($$v) {
                    _vm.$set(_vm.form.styleSetting, "showPrice", $$v)
                  },
                  expression: "form.styleSetting.showPrice",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "是否分页：" } },
            [
              _c("el-switch", {
                attrs: {
                  "active-value": 1,
                  "active-text": "是",
                  "inactive-text": "否",
                  "inactive-value": 0,
                },
                model: {
                  value: _vm.form.styleSetting.showPage,
                  callback: function ($$v) {
                    _vm.$set(_vm.form.styleSetting, "showPage", $$v)
                  },
                  expression: "form.styleSetting.showPage",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.form.styleSetting.showPage
            ? _c(
                "el-form-item",
                { attrs: { label: "商品每页数量：" } },
                [
                  _c("el-input-number", {
                    attrs: { min: 1 },
                    model: {
                      value: _vm.form.styleSetting.pageLimit,
                      callback: function ($$v) {
                        _vm.$set(_vm.form.styleSetting, "pageLimit", $$v)
                      },
                      expression: "form.styleSetting.pageLimit",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.isAlone
            ? _c(
                "el-form-item",
                { attrs: { label: "主题风格：" } },
                [
                  _c("el-color-picker", {
                    attrs: { "show-alpha": "" },
                    model: {
                      value: _vm.form.styleSetting.titleColor,
                      callback: function ($$v) {
                        _vm.$set(_vm.form.styleSetting, "titleColor", $$v)
                      },
                      expression: "form.styleSetting.titleColor",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "背景图片：" } }, [
            _c(
              "div",
              {
                staticClass: "bg-img flex",
                on: {
                  click: function ($event) {
                    return _vm.uploadbgImg("bgImg")
                  },
                },
              },
              [
                _vm.form.styleSetting.bgImg
                  ? _c("img", { attrs: { src: _vm.form.bgImg } })
                  : _c("i", { staticClass: "el-icon-camera cameraIconfont" }),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "背景色：" } },
            [
              _c("el-color-picker", {
                attrs: { "show-alpha": "" },
                model: {
                  value: _vm.form.styleSetting.bgColor,
                  callback: function ($$v) {
                    _vm.$set(_vm.form.styleSetting, "bgColor", $$v)
                  },
                  expression: "form.styleSetting.bgColor",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "内间距：" } }, [
            _c(
              "div",
              { staticClass: "flex", staticStyle: { "margin-bottom": "5px" } },
              [
                _c("div", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("上："),
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  attrs: { min: 0 },
                  model: {
                    value: _vm.form.marketPadding.pt,
                    callback: function ($$v) {
                      _vm.$set(_vm.form.marketPadding, "pt", $$v)
                    },
                    expression: "form.marketPadding.pt",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex", staticStyle: { "margin-bottom": "5px" } },
              [
                _c("div", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("下："),
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  attrs: { min: 0 },
                  model: {
                    value: _vm.form.marketPadding.pb,
                    callback: function ($$v) {
                      _vm.$set(_vm.form.marketPadding, "pb", $$v)
                    },
                    expression: "form.marketPadding.pb",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex", staticStyle: { "margin-bottom": "5px" } },
              [
                _c("div", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("左："),
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  attrs: { min: 0 },
                  model: {
                    value: _vm.form.marketPadding.pr,
                    callback: function ($$v) {
                      _vm.$set(_vm.form.marketPadding, "pr", $$v)
                    },
                    expression: "form.marketPadding.pr",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex", staticStyle: { "margin-bottom": "5px" } },
              [
                _c("div", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("右："),
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  attrs: { min: 0 },
                  model: {
                    value: _vm.form.marketPadding.pl,
                    callback: function ($$v) {
                      _vm.$set(_vm.form.marketPadding, "pl", $$v)
                    },
                    expression: "form.marketPadding.pl",
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "内部间距：" } },
            [
              _c("el-input-number", {
                attrs: { min: 0 },
                model: {
                  value: _vm.form.marketPadding.midP,
                  callback: function ($$v) {
                    _vm.$set(_vm.form.marketPadding, "midP", $$v)
                  },
                  expression: "form.marketPadding.midP",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("EditMarket", {
        ref: "EditMarketRef",
        on: { saveEdit: _vm.saveEdit },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }